
import { Component, Vue } from 'vue-property-decorator'
import RowItem from '@/components/detail/row_item/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import { SecurityService } from '@/services'

interface IStatus { key: number, value: string }
const statusOptions: IStatus[] = [{ key: 1, value: '未处理' }, { key: 2, value: '已处理' }]

@Component({
    components: {
        RowItem,
        RowWrap
    },
    name: 'complaint-detail'
})
export default class extends Vue {
    private detail: any = {}

    private created() {
        this.getDetail()
    }

    private async getDetail() {
        const params = { id: Number(this.$route.params.id) }
        const result = await SecurityService.getComplaint(params)
        if (result.status === 200) {
            this.detail = result.data
        }
    }

    private statusMap(status: number) {
        const item: any = statusOptions.find(item => item.key === status)
        return item.value
    }
}
